import { useQuery } from "@tanstack/react-query";
import { documentTagsService } from "../../../../../services/document/document-tags.service";
import _ from "lodash";
import { useCallback, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

export const useDocumentTags = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["document-tags"],
    queryFn: () => documentTagsService.getRequests(),
    select: (res: any) =>
      _.sortBy(
        res.value.map((e: any) => ({ id: e.id, Title: e.fields.Title, eTagType: e.fields.eTagType })),
        "createdDateTime",
      ),
  });

  const groupedByTagType = useMemo(() => _.groupBy(data, "eTagType"), [data]);

  const dataOptions = useMemo(
    () =>
      Object.keys(groupedByTagType).map((key) => ({
        label: key,
        title: key,
        options: groupedByTagType[key].map((e) => ({ label: e.Title, value: e.id })),
      })),
    [groupedByTagType],
  );

  const tagTypeTableData = useMemo(
    () =>
      Object.keys(groupedByTagType).map((key) => ({
        key: uuidv4(),
        tagType: key,
        tags: [...groupedByTagType[key]],
      })),
    [groupedByTagType],
  );

  const eTagTypeOptions = useMemo(() => {
    const uniqArr = _.unionBy(data, "eTagType");
    return uniqArr.map((e: any) => {
      return {
        text: e.eTagType,
        value: e.eTagType,
      };
    });
  }, [data]);

  const getDataByTagType = useCallback((tagType: string) => data?.filter((e: any) => e.eTagType === tagType), [data]);

  const getTagLabel = useCallback((id: string) => data?.find((e: any) => e.id === id)?.Title || "", [data]);

  return { data, isLoading, dataOptions, tagTypeTableData, eTagTypeOptions, getDataByTagType, getTagLabel };
};
